import { FiThumbsUp } from "react-icons/fi";
import { IoShareSocialOutline } from "react-icons/io5";
import { AiOutlineComment } from "react-icons/ai";
import { GoGraph } from "react-icons/go";
import MUImg01 from '../../../assets/images/TrainingResourcesImages/TR-DocumentImg01.svg';
import MUImg02 from '../../../assets/images/TrainingResourcesImages/TR-DocumentImg02.svg';
import MUImg03 from '../../../assets/images/TrainingResourcesImages/TR-DocumentImg03.svg';

export const bulkOrders = [
    { label: "Pending Orders", count: "15" },
    { label: "In Progress Orders", count: "15" },
    { label: "Completed Orders", count: "15" },
];

export const headers = ['Product', 'Customer', 'Product ID', 'Price', 'Stock', 'Sold', 'Status'];

export const data = [
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },  // Image and text in second column
        '#123456789', '$33.99', '300', '40', 'Pending'
    ],
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },
        '#123456790', '$23.99', '200', '30', 'Pending'
    ],
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },  // Image and text in second column
        '#123456791', '$13.99', '150', '20', 'Ready to ship'
    ],
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },
        '#123456792', '$43.99', '120', '10', 'Delivered'
    ],
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },  // Image and text in second column
        '#123456793', '$53.99', '500', '50', 'Pending'
    ],
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },
        '#123456792', '$43.99', '120', '10', 'Delivered'
    ],
    [
        require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        { image: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderCustomerImg.png"), text: 'James' },
        '#123456794', '$33.99', '350', '60', 'Ready to ship'
    ]
];

export const upcomingEvent = [
    { src: require("../../../assets/images/SellerPortalImages/DashboardImages/UpcomingEventImg.png"), title: "Maelano Summer Sale", startDate: "05/05/2024", duration: "30 days" },
    { src: require("../../../assets/images/SellerPortalImages/DashboardImages/UpcomingEventImg.png"), title: "Maelano Summer Sale", startDate: "05/05/2024", duration: "30 days" }
];

export const discountPromotions = [
    { label: "Active Promotions", count: "10" },
    { label: "Active Coupons", count: "5" },
    { label: "Active vouchers", count: "10" },
    { label: "Amount Redeemed", count: "$3000" },
    { label: "Active Promotions", count: "10" },
    { label: "Active Coupons", count: "5" },
    { label: "Active vouchers", count: "10" },
];

export const recentReviewsData = [
    {
        name: 'James Watson',
        time: 'Just now',
        rating: '5.0',
        review: 'These headphones are fantastic! The sound quality is top-notch, with great bass and clear highs. Noise-canceling is excellent, and the battery lasts almost two days. They’re comfortable for long use and easy to pair with devices. Highly recommended!',
    },
    {
        name: 'James Watson',
        time: 'Just now',
        rating: '3.0',
        review: 'These headphones are fantastic! The sound quality is top-notch, with great bass and clear highs. Noise-canceling is excellent, and the battery lasts almost two days. They’re comfortable for long use and easy to pair with devices. Highly recommended!',
    }
];

export const loyaltyData = [
    { label: 'Total members', value: '2500' },
    { label: 'Points Earned', value: '450,000' },
    { label: 'Points Redeemed', value: '300,000' },
    { label: 'Rewards Issued', value: '1,000' },
    { label: 'Customer Satisfaction Score', value: '4.8/5' },
];

export const socialMediaData = [
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SocialMediaInsightImages/Instagram-Img01.png"),
        icons: [FiThumbsUp, IoShareSocialOutline, AiOutlineComment],
        iconValue: [1500, 400, 1500],
        label: "Followers growth", count: "+300"
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SocialMediaInsightImages/Twitter-Img02.png"),
        icons: [FiThumbsUp, IoShareSocialOutline, AiOutlineComment],
        iconValue: [1500, 400, 1500],
        label: "Followers growth", count: "+300"
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SocialMediaInsightImages/Youtube-Img03.png"),
        icons: [FiThumbsUp, IoShareSocialOutline, AiOutlineComment],
        iconValue: [1500, 400, 1500],
        label: "Followers growth", count: "+300"
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SocialMediaInsightImages/Facebook-Img04.png"),
        icons: [FiThumbsUp, IoShareSocialOutline, AiOutlineComment],
        iconValue: [1500, 400, 1500],
        label: "Followers growth", count: "+300"
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SocialMediaInsightImages/Linkedin-Img05.png"),
        icons: [FiThumbsUp, IoShareSocialOutline, AiOutlineComment],
        iconValue: [1500, 400, 1500],
        label: "Followers growth", count: "+300"
    }
];

export const progressData = [
    { value: 80, text: 'Positive', color: '#41B8E4' }, // Blue for positive
    { value: 20, text: 'Negative', color: '#EC7426' }, // Red for negative
];

export const productStatusData = [
    { label: "Total Products", count: "600" },
    { label: "Under Approval", count: "20" },
    { label: "Online", count: "565" },
    { label: "Out of Stock", count: "15" },
    { label: "Rejected", count: "05" },
    { label: "Total Products", count: "600" },
    { label: "Under Approval", count: "20" },
];

export const topSellingProducts = [
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        title: "Blue headphones", amount: "$33.99", quantity: "30 stocks left",
        statusLabels: ["Items Sold", "Revenue"],
        statusCounts: ["600", "$12,000"],
        graphIcon: GoGraph
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        title: "Blue headphones", amount: "$33.99", quantity: "30 stocks left",
        statusLabels: ["Items Sold", "Revenue"],
        statusCounts: ["600", "$12,000"],
        graphIcon: GoGraph
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        title: "Blue headphones", amount: "$33.99", quantity: "30 stocks left",
        statusLabels: ["Items Sold", "Revenue"],
        statusCounts: ["600", "$12,000"],
        graphIcon: GoGraph
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        title: "Blue headphones", amount: "$33.99", quantity: "30 stocks left",
        statusLabels: ["Items Sold", "Revenue"],
        statusCounts: ["600", "$12,000"],
        graphIcon: GoGraph
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        title: "Blue headphones", amount: "$33.99", quantity: "30 stocks left",
        statusLabels: ["Items Sold", "Revenue"],
        statusCounts: ["600", "$12,000"],
        graphIcon: GoGraph
    },
    {
        imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/OverviewPanelImages/OrderProductImg.png"),
        title: "Blue headphones", amount: "$33.99", quantity: "30 stocks left",
        statusLabels: ["Items Sold", "Revenue"],
        statusCounts: ["600", "$12,000"],
        graphIcon: GoGraph
    }
];

export const financialData = [
    { heading: "Sales summary", firstStat: { label: 'Total Sales', value: '$50,000', percent: "+10%" }, secondStat: { label: 'Total Orders', value: '1,000', percent: "+10%" } },
    { heading: "Earnings", firstStat: { label: 'Net Earnings', value: '$45,000', percent: "+10%" }, secondStat: { label: 'Payouts', value: '$42,000', percent: "+10%" } },
    { heading: "Fees and Deductions", firstStat: { label: 'Platform Fees', value: '$3,000', percent: "+10%" }, secondStat: { label: 'Return Deductions', value: '$2,000', percent: "+10%" } },
    { heading: "Taxes", firstStat: { label: 'Collected Taxes', value: '$5,000', percent: "+10%" }, secondStat: { label: 'Paid Taxes', value: '$4,500', percent: "+10%" } },
];

export const supportData = [
    { imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SupportResourcesImages/Support-Img01.png"), heading: "Contact and Support" },
    { imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SupportResourcesImages/Support-Img02.png"), heading: "Terms and Policies" },
    { imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SupportResourcesImages/Support-Img03.png"), heading: "Customer Services " },
    { imgSrc: require("../../../assets/images/SellerPortalImages/DashboardImages/SupportResourcesImages/Support-Img04.png"), heading: "Testimonials" },
];

export const maelanoUniData = [
    {
        heading: 'Video',
        title: 'Setting Up Your Shop',
        imgSrc: MUImg01,
    },
    {
        heading: 'Document Guide',
        title: 'Order Fulfillment Checklist',
        imgSrc: MUImg02,
    },
    {
        heading: 'Document Guide',
        title: 'Promotional Campaign Planner',
        imgSrc: MUImg03,
    },
];